// middleware/www-injection.js
import path from 'path';

function isFileRequest(url) {
  const fileExtensions = ['.html', '.css', '.js', '.png', '.jpg', '.jpeg', '.gif', '.pdf', '.svg', '.webp', '.webm', '.mp4', '.xml', '.txt', '.map', '.json', '.ico'];
  const extname = path.extname(url);
  return fileExtensions.includes(extname.toLowerCase());
}

export function wwwInjectionFunction({ req, i18n, $cookies, urlString }): string {

  let url = urlString;
  const is301Redirected = $cookies.get("301redirected");
  if ((process.env.NODE_ENV === "production" && process.env.CURRENT_ENV !== 'prod') || url == "/_loading/sse" || url.includes('?') || is301Redirected) {
    return;
  }
  
  const curLocale = i18n.localeProperties.code;

  const host = url.startsWith('/') ? req.headers["x-forwarded-host"] || req.hostname : new URL(url).host;
  const isWWW = /^www\./.test(host);
  const shouldNotRedirect = isWWW && url.startsWith(`/${curLocale}`);
  const isFileReq = isFileRequest(url);

  if (shouldNotRedirect || isFileReq) {
    return;
  }

  if(!url.startsWith('/')) {
    url = new URL(url).pathname;
  }
  // Perform the redirection
  const redirectUrl = url.startsWith(`/${curLocale}`) ? `${process.env.INSTANCE_URL}${url}` : `${process.env.INSTANCE_URL}/${curLocale}${url}`;
  return(redirectUrl);
}
